import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["delimiter", "size", "margin", "padding", "elementRef", "children", "spacing", "styles"];
var _dec, _dec2, _class, _InlineListItem;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { View } from '@instructure/ui-view';
import { testable } from '@instructure/ui-testable';
import { passthroughProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
parent: InlineList
id: InlineList.Item
---
**/
let InlineListItem = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_InlineListItem = class InlineListItem extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      delimiter = _this$props3.delimiter,
      size = _this$props3.size,
      margin = _this$props3.margin,
      padding = _this$props3.padding,
      elementRef = _this$props3.elementRef,
      children = _this$props3.children,
      spacing = _this$props3.spacing,
      styles = _this$props3.styles,
      rest = _objectWithoutProperties(_this$props3, _excluded);
    return _jsxs(View, {
      ...passthroughProps(rest),
      css: styles === null || styles === void 0 ? void 0 : styles.inlineListItem,
      as: "li",
      margin: margin,
      padding: padding,
      display: "inline-block",
      maxWidth: "100%",
      elementRef: this.handleRef,
      children: [children, _jsx("span", {
        css: styles === null || styles === void 0 ? void 0 : styles.delimiter,
        "aria-hidden": "true"
      })]
    });
  }
}, _InlineListItem.displayName = "InlineListItem", _InlineListItem.componentId = 'InlineList.Item', _InlineListItem.propTypes = propTypes, _InlineListItem.allowedProps = allowedProps, _InlineListItem.defaultProps = {
  padding: 'none',
  spacing: 'none',
  delimiter: 'none',
  size: 'medium'
}, _InlineListItem)) || _class) || _class);
export default InlineListItem;
export { InlineListItem };